// Rareté d'une carte → symbole officiel (● ◆ ★ ★★ ★★★, ceux imprimés en bas
// des cartes), couleur du palier et libellé. TCGdex sert les raretés en
// français sur /fr (« Commune », « Illustration rare »…) mais parfois en
// anglais (« Futuristic Rare », « HIGH-TECG rare ») : on reconnaît par
// mots-clés dans les deux langues, sans jamais inventer — une rareté
// inconnue garde son texte tel quel, en gris.
const TIERS = {
  common:   { glyph: "●",   color: "#b4b4bf" },
  uncommon: { glyph: "◆",   color: "#5fd3a5" },
  rare:     { glyph: "★",   color: "#7ab8ff" },
  double:   { glyph: "★★",  color: "#c4a4ff" },
  ultra:    { glyph: "★★",  color: "#d8b4fe" },
  ir:       { glyph: "★",   color: "#f5c452" },
  sir:      { glyph: "★★",  color: "#ff9ad5" },
  hyper:    { glyph: "★★★", color: "#ffe9a3" },
  secret:   { glyph: "★★★", color: "#ffe9a3" },
  pika:     { glyph: "⚡",  color: "#ffd84d" },
  promo:    { glyph: "★",   color: "#fb923c" },
  ace:      { glyph: "◆",   color: "#ff8fab" },
  shiny:    { glyph: "✦",   color: "#9ae6ff" },
  none:     { glyph: "",    color: "#8a8a96" },
};

function tierOf(r) {
  if (!r) return "none";
  const s = r.toLowerCase();
  if (/sans raret|no rarity|none/.test(s)) return "none";
  if (/pikachu/.test(s)) return "pika";
  if (/ace spec|high-tec/.test(s)) return "ace";
  if (/hyper|futur|rainbow|arc-en-ciel|gold|dor[ée]/.test(s)) return "hyper";
  if (/secr|secret/.test(s)) return "secret";
  if (/sp[ée]ciale|special/.test(s) && /illustr/.test(s)) return "sir";
  if (/illustr/.test(s)) return "ir";
  if (/shiny|chromatique|brillant|radieu|radiant|amazing|magnifique/.test(s)) return "shiny";
  if (/ultra|holo (ex|gx|v|vmax|vstar|lv)|prime|legend|break/.test(s)) return "ultra";
  if (/double/.test(s)) return "double";
  if (/promo/.test(s)) return "promo";
  if (/peu commune|uncommon/.test(s)) return "uncommon";
  if (/commune|common/.test(s)) return "common";
  if (/rare/.test(s)) return "rare";
  return "none";
}

/** {glyph, color, label} pour une rareté TCGdex (label = texte d'origine). */
export function rarityInfo(rarity) {
  const tier = tierOf(rarity);
  return { ...TIERS[tier], tier, label: rarity || "" };
}
